<div class="d-flex flex-column align-items-center px-4 py-3 mx-auto card-container">
  <div class="card-media">
    <div class="d-flex canavs-totalsales">
      <div class="d-flex flex-column align-items-center w-100 text-wrapper">
        <p class="font-weight-bolder align-self-start first-header">Sold products</p>
        <p class="font-weight-bolder second-header">{{ dashboardData?.sold_quantity ? (dashboardData?.sold_quantity | number) : 0 }}</p>
        <p class="third-header">Products</p>
      </div>
      <div class="canavas-commission-container d-flex align-items-center flex-column">
        <div>
          <canvas #soldProducts></canvas>
        </div>
      </div>
    </div>
    <div class="d-flex align-items-center w-100 commission-legend">
      <div #legendContainer id="sold-products-legend-container" class="w-100 align-self-start legend-container">
        <ul>
          <li><span class="legend-bullet"></span> Online: {{ online ? (online | number) : 0 }} {{ currencySlug | uppercase }}</li>
          <li><span class="legend-bullet"></span> Onsite: {{ onsite ? (onsite | number) : 0 }} {{ currencySlug | uppercase }}</li>
        </ul>
      </div>
    </div>
  </div>
</div>
